// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"HR","fixed":"IR","nonLayerdFacets":"JR","productCount":"KR","facetBack":"LR","arrow":"MR"};